module.exports = __webpack_public_path__ + "static/media/pay_refunding.cb97d156.svg";